import { OnDestroy, OnInit, Directive, inject, Component, ChangeDetectionStrategy } from "@angular/core";
import { Subscription } from "rxjs";
import { IMetadataImage } from "../../interfaces/i-metadataimage";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-image-info",
  templateUrl: "./image-info.component.html",
  styleUrls: ["./image-info.component.scss"],
  standalone: false,
})
export class ImageInfoComponent implements OnInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  subscriptions: Subscription[] = [];

  selectedImage: IMetadataImage;

  ngOnInit() {
    this.subscriptions.push(
      this.viewerService.image$.subscribe((image: IMetadataImage) => {
        if (image) {
          this.selectedImage = image;
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  isVisible(): boolean {
    return !!this.selectedImage;
  }
}
